module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-con"
  }, [_c('div', {
    staticClass: "step-icon"
  }, [_c('i', {
    class: ['iconfont', _vm.icon]
  })]), _vm._v(" "), _c('div', {
    staticClass: "step-name"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.name))])], 2), _vm._v(" "), _c('div', {
    staticClass: "step-num"
  }, [_c('span', [_vm._v(_vm._s(_vm.step))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30cdbb2c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iexplore/components/steps/src/Step.vue
// module id = 1203
// module chunks = 2